<template>
    <Breadcrumbs main="Project" title="Project List" />
    <div class="container-fluid">
        <div class="row project-cards">
            <projectTab />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'

const projectTab = defineAsyncComponent(() => import("@/components/theme/project/projectlist/projectTab.vue"))
</script>